import decode from 'jwt-decode';

import {
  hasAuthCookie,
  getAuthCookie,
} from '@giro/shared-utils/authCookie.util';

const initialState = {
  signedIn: hasAuthCookie(),
  token: hasAuthCookie() ? getAuthCookie() : null,
  user: hasAuthCookie() ? decode(getAuthCookie()) : null,
  reason: null,
};

export default initialState;
